var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21277_341299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21277_341299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.5833C11.042 14.5833 11.9274 14.2188 12.6566 13.4896C13.3857 12.7604 13.7503 11.875 13.7503 10.8333C13.7503 9.79167 13.3857 8.90625 12.6566 8.17708C11.9274 7.44792 11.042 7.08333 10.0003 7.08333C8.95866 7.08333 8.07324 7.44792 7.34408 8.17708C6.61491 8.90625 6.25033 9.79167 6.25033 10.8333C6.25033 11.875 6.61491 12.7604 7.34408 13.4896C8.07324 14.2188 8.95866 14.5833 10.0003 14.5833ZM10.0003 12.9167C9.41699 12.9167 8.92394 12.7153 8.52116 12.3125C8.11838 11.9097 7.91699 11.4167 7.91699 10.8333C7.91699 10.25 8.11838 9.75694 8.52116 9.35417C8.92394 8.95139 9.41699 8.75 10.0003 8.75C10.5837 8.75 11.0767 8.95139 11.4795 9.35417C11.8823 9.75694 12.0837 10.25 12.0837 10.8333C12.0837 11.4167 11.8823 11.9097 11.4795 12.3125C11.0767 12.7153 10.5837 12.9167 10.0003 12.9167ZM3.33366 17.5C2.87533 17.5 2.48296 17.3368 2.15658 17.0104C1.83019 16.684 1.66699 16.2917 1.66699 15.8333V5.83333C1.66699 5.375 1.83019 4.98264 2.15658 4.65625C2.48296 4.32986 2.87533 4.16667 3.33366 4.16667H5.95866L7.00033 3.04167C7.1531 2.875 7.33713 2.74306 7.55241 2.64583C7.76769 2.54861 7.99338 2.5 8.22949 2.5H11.7712C12.0073 2.5 12.233 2.54861 12.4482 2.64583C12.6635 2.74306 12.8475 2.875 13.0003 3.04167L14.042 4.16667H16.667C17.1253 4.16667 17.5177 4.32986 17.8441 4.65625C18.1705 4.98264 18.3337 5.375 18.3337 5.83333V15.8333C18.3337 16.2917 18.1705 16.684 17.8441 17.0104C17.5177 17.3368 17.1253 17.5 16.667 17.5H3.33366ZM3.33366 15.8333H16.667V5.83333H13.292L11.7712 4.16667H8.22949L6.70866 5.83333H3.33366V15.8333Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1d8ed3eaff1f5647c68d54c8fc8608da.svg";
export { ForwardRef as ReactComponent };